import { useEffect, useState } from "react";
import { _AccountINFORPO, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../../../modules/theme/Component/BasicTable"
import usePaginator from "../../../../../../../modules/theme/Component/usePaginator";
import { BasicButton } from "../../../../../../../modules/theme/Component/BasicButton";
import { DropDown } from "../../../../../../../modules/theme/Component/DropDown";
import { toast } from "react-toastify";

interface Props {
    _idAccount: number
    Credit: any;
}


export const AmortizationCreditInfo = ({ Credit, _idAccount }: Props) => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_AccountINFORPO);
    const paginador = usePaginator();
    const [year, setYear] = useState<number>(_single.getCurrenYear());

    useEffect(() => {
        if (_idAccount && Credit.IDCreditAccount) {
            getAmortization()
        }
    }, [paginador.page, Credit]);

    const getAmortization = () => {
        const props = {
            IDAccount: _idAccount,
            IDCreditAccount: Credit.IDCreditAccount,
            // FromYear: year
        }
        instance.getAmortizacionRender(paginador.page, 15, _single.cleanMap(props)).then(
            (resp) => {
                setLista(resp.List)
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const headAmortizacion = [
        { title: 'ID', property: 'IDCuotaCredito', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha de Cuota', property: 'FechaCuota', visible: true, mask: MASK_DATE },
        { title: 'Numero de Cuota', property: 'NoCuota', visible: true, mask: MASK_NUMBER },
        { title: 'Tasa de Interes Fijo', property: 'InteresFijo', visible: true, mask: MASK_MONEY },
        { title: 'Tasa de Interes Variable', property: 'InteresVariable', visible: true, mask: MASK_MONEY },
        { title: 'Tasa de Interes', property: 'TasaInteres', visible: true, mask: MASK_MONEY },
        { title: 'Valor del Capital', property: 'ValorCapital', visible: true, mask: MASK_MONEY },
        { title: 'Valor de la Cuota', property: 'ValorCuota', visible: true, mask: MASK_MONEY },
        { title: 'Saldo de Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
        { title: 'Forma de Pago', property: 'FormaPago', visible: true },
        { title: 'Tipo de Cuota', property: 'TipoCuota', visible: true },
    ]
    const actionsDropDown = [
        { id: 1, name: 'Migrar Amortización', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            if (Credit.IDCreditAffiliate && Credit.IDCreditAccount) {

                                instance.actualizarAmortizacion(Credit.IDCreditAffiliate, Credit.IDCreditAccount).then(
                                    (resp: any) => {
                                        toast.success("Amortización Actualizada");
                                    }
                                )
                            }
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <div className="row">
            {/* <div className="col-md-3">
                <label>Año</label>
                <input type="number" name="Year" className="form-control" value={year} onChange={(e) => { setYear(parseInt(e.target.value)) }} />
            </div>
            <div className="col-md-4">
                <BasicButton icon="" useMargin eventClick={getAmortization}>Buscar</BasicButton>
            </div> */}
            <div className="col-md-12">
                <BasicTable
                    headButtons={buttons()}
                    body={lista}
                    head={headAmortizacion}
                    rowSet={setBean}
                    records={paginador}
                />
            </div>
        </div>
    )
}